// @flow
import { Building, CreditCard, Key, User, Users } from '@phosphor-icons/react'
import { useAuthContext } from 'auth/authContext'
import Loading from 'components/Loading'
import usePermissions from 'hooks/usePermissions'
import * as React from 'react'
import { Helmet } from 'react-helmet'
import { useHistory } from 'react-router-dom'
import Ui from 'ui'
import Title from 'ui/atoms/Title'
import { ZentakeContext } from 'utils/ZentakeContext'

import ProfileContent from './profile/ProfileContent'

const PROFILE_STANDARD_TABS = [
  {
    id: 'profile',
    title: (
      <>
        <User className="text-base" /> Profile
      </>
    ),
  },
  {
    id: 'organization',
    title: (
      <>
        <Building className="text-base" /> Organization
      </>
    ),
  },
  {
    id: 'billing',
    title: (
      <>
        <CreditCard className="text-base" /> Billing
      </>
    ),
  },
  {
    id: 'team',
    title: (
      <>
        <Users className="text-base" /> Team
      </>
    ),
  },
  {
    id: 'roles',
    title: (
      <>
        <Key className="text-base" /> Roles
      </>
    ),
  },
]

function Profile(): React.Node {
  const { loading, user } = useAuthContext()
  const { isAdminUser, canManageTeamUsers } = usePermissions()
  const history = useHistory()

  const { updateUserDetails } = React.useContext(ZentakeContext)

  const onSelectOption = ({ id }: { id: number }) => history.replace(`#${id}`)

  const currentPage = window.location.hash.replace('#', '') || 'profile'

  const allowedTabs = PROFILE_STANDARD_TABS.filter((tab) => {
    if (tab.id === 'roles') {
      return isAdminUser
    }
    if (tab.id === 'team') {
      return isAdminUser || canManageTeamUsers
    }
    return true
  })

  const currentSelectedTabs = PROFILE_STANDARD_TABS.findIndex(
    (item) => item.id === currentPage
  )

  React.useEffect(() => {
    updateUserDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading || !user) {
    return <Loading />
  }

  return (
    <>
      <Helmet>
        <title>Profile/Zentake</title>
      </Helmet>

      <div className="mx-auto mt-6 max-w-screen-xl pb-11 md:px-3">
        <div className="mx-auto max-w-screen-xl">
          <div className="mb-4 w-full lg:mb-0">
            <Title>Account</Title>
          </div>
        </div>

        <div>
          <Ui.Tabs
            initialSelectedIndex={currentSelectedTabs}
            onSelectOption={onSelectOption}
            options={allowedTabs}
          />
          <ProfileContent selectedTab={currentPage} />
        </div>
      </div>
    </>
  )
}

export default Profile
